import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Faq } from '../../../../core/models/faq';

@Component({
  selector: 'mapfre-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit {
  @Input() faqs: Faq[] = [];

  indexOpen;

  constructor() {}

  ngOnInit() {
    this.indexOpen = (this.faqs ?? []).findIndex(({ opened }) => opened);
  }

  toggle(i) {
    this.indexOpen = this.indexOpen === i ? null : +i;
  }
}
